module.exports = __webpack_public_path__ + "img/tow-addon.3e5f3aa0.svg";